/**
 * Web Style Import
 *
 */

import './style/dnb-upload.scss'
